(function ($) {
    $(() => {
        
        /* Match hight */
        $('.match-h').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });

        $('.match-h-h').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });

        $('.match-h-2').matchHeight({
            byRow: false,
            property: 'height',
            target: null,
            remove: false
        });

        $('.js-open-info-box').on('click', function() {
            $(this).parent().find('.js-info-box').toggleClass('open');
        });


        $(document).ready(function() {
            $('.js-copy-clipboard').click(function() {
                var pageURL = window.location.href;
                copyToClipboard(pageURL);
            });
        });
        
        function copyToClipboard(text) {
            var tempInput = $("<input>");
            $("body").append(tempInput);
            tempInput.val(text).select();
            document.execCommand("copy");
            tempInput.remove();
        }

    });

    function resizeInfoBlock2() {
        $('.section-info-block-2__image-wrapper').each(function() {
            let img = $(this).find('img');

            if (img.length > 0) {
                let imgHeight = img.prop('height');
                let imgTop = parseInt(img.css('top').replace('px', ''));

                $(this).css('height', imgHeight + imgTop + 'px');
            }
        });
    }

    function resizeQuestionBoxes() {
        $('.section-question').each(function() {
            let boxLeft = $(this).find('.section-question__wrapper-2');
            let boxRight = $(this).find('.section-question__wrapper-1');

            if ($(window).width() > 768) {
                let boxLeftHeight = boxLeft.innerHeight();
                let boxRightHeight = boxRight.innerHeight();
                let height = boxLeftHeight > boxRightHeight ? boxLeftHeight : boxRightHeight;

                boxLeft.css('height', height + 'px');
                boxRight.css('height', height + 'px');
            } else {
                boxLeft.css('height', 'auto');
                boxRight.css('height', 'auto');
            }
        });
    }

    function resizeSectionTransformText() {
        $('.section-transform-text').each(function() {
            let imageWrapper = $(this).find('.image');
            let contentWrapper = $(this).find('.content');

            if ($(window).width() > 576) {
                let imageOffset = imageWrapper.data('offsetDesktop');
                let contentOffset = contentWrapper.data('offsetDesktop');

                if ($(window).width() < 769) {
                    imageOffset = imageWrapper.data('offsetTablet');
                    contentOffset = contentWrapper.data('offsetTablet');
                }

                imageWrapper.css('margin-top', imageOffset + 'px');
                contentWrapper.css('margin-top', contentOffset + 'px');

                let imageHeight = parseInt(imageWrapper.height()) + parseInt(imageOffset);
                let contentHeight = parseInt(contentWrapper.height()) + parseInt(contentOffset);
                let height = imageHeight > contentHeight ? imageHeight : contentHeight;

                $(this).find('.wrapper').css('height', height + 'px');
            } else {
                imageWrapper.css('margin-top', '0px');
                contentWrapper.css('margin-top', '0px');
            }
        });
    }

    $(window).on('resize', function() {
        resizeInfoBlock2();
        resizeQuestionBoxes();
        resizeSectionTransformText();
    });

    $(document).ready(function() {
    
        resizeInfoBlock2();
        resizeQuestionBoxes();
        resizeSectionTransformText();
    });

  

})(jQuery);

